<mat-card appearance="raised" class="payment-card">
  <mat-progress-bar class="progress-loader"
    [mode]="loadingIndicator || componentLoadingIndicator? 'indeterminate' : 'determinate'" value="0"
  color="primary"></mat-progress-bar>
  <mat-card-content class="card-content">
    @if (paymentProviderConfig && !(showFailureMessage || showSuccessMessage)) {
      @if (loadingIndicator) {
        <div style="width: 75%; display: flex; justify-content: flex-start; align-items: center; flex-direction: column;">
          <ng-lottie [options]="loadingOptions"></ng-lottie>
        </div>
      } @else {
        @if (paymentProviderConfig.provider === 'STRIPE') {
          <div style="margin-top: 16px">
            <app-stripe (change)="stripePaymentEvent($event)" [paymentIntent]="stripePaymentIntent"></app-stripe>
          </div>
        }
        <!--<app-secure-pay *ngIf="paymentProviderConfig.provider === 'SECURE_PAY' || 'SECURE_PAY_TEST'"
        [paymentProviderConfig]="paymentProviderConfig"
        (tokenChange)="payWithToken($event)"
        (dccQuoteChange)="dccQuoteChange($event)"
        [dccToken]="dccOrderToken"
        [dccId]="dccOrderId"
        [disabled]="!billingAddress"
      [resetHook]="paymentGatewayResetObservable.asObservable()"></app-secure-pay>-->
    }
  }

  @if (showSuccessMessage) {
    <mat-icon color="primary" style="font-size: 75px">done_outline</mat-icon>
    <br/>
    <p>Thank you for paying. This invoice has been paid in full.</p>
  }

  @if (showFailureMessage) {
    <mat-icon color="warn" style="font-size: 75px">close</mat-icon>
    <br/>
    <p>The payment was not successful, please try again by clicking retry!</p>
    <p>Message: <i>{{errorMessage ? errorMessage : 'No error message'}}</i></p>
    <button matButton="filled" (click)="refreshPayment()">RETRY</button>
  }
</mat-card-content>
</mat-card>


